import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import './App.css';
import Reviews from './pages/Reviews';
import Discovery from './pages/Discovery';
import BinaryClassification from './pages/BinaryClassification';
import BinaryClassificationViz from './pages/BinaryClassificationViz';
import MLEnhancements from './pages/MLenhancements';
import Clustering from './pages/Clustering';
import Finishing from './pages/Finishing';
import Model from './pages/Model';

const App = () => (
  <Router>
    <Header />
    <main className="content">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<Projects />} />
          <Route path="/discovery" element={<Discovery />} />
            <Route path="/binaryclassification" element={<BinaryClassification />} />
            <Route path='/BinaryClassificationViz' element={<BinaryClassificationViz/>}/>
            <Route path='/enhancements' element={<MLEnhancements/>}/>
            <Route path='/clustering' element={<Clustering/>}/>
                 <Route path='/finishing' element={<Finishing/>}/>
                 <Route path='/model' element={<Model/>}/>
        <Route path="/reviews" element={<Reviews />} />
      </Routes>
    </main>
    <Footer />
  </Router>
);

export default App;